var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/twotone/save-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.4501 29.8574H25.5499C16.9999 29.8574 10 36.8573 10 45.4073V102.207C10 109.457 15.2 112.557 21.55 109.007L41.2 98.0573C43.3 96.9073 46.7 96.9073 48.75 98.0573L68.4 109.007C74.75 112.557 79.95 109.457 79.95 102.207V45.4073C80 36.8573 73.0001 29.8574 64.4501 29.8574Z",
    stroke: "#A461D8",
    strokeWidth: 2.47186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M110 26.0031V82.8031C110 90.0531 104.8 93.1031 98.45 89.6031L80 79.3031V45.4031C80 36.8531 73.0001 29.8531 64.4501 29.8531H40V26.0031C40 17.4531 46.9999 10.4531 55.5499 10.4531H94.4501C103 10.4531 110 17.4531 110 26.0031Z",
    stroke: "#A461D8",
    strokeWidth: 2.47186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.db447a88b396677ce6c9f8b2671e563e.svg";
export { ForwardRef as ReactComponent };